import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./ProductDetails.css";
import BaseButton from "../Common/BaseButton";
import Button from 'react-bootstrap/Button';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useProductContext } from "../Context/ProductContext";

const ProductHowToUse = (props) => {
  const { howtoUse, handleProductRegenerate, previewMode, loading, initialSku, keywords: propKeywords, handleManualEdit, onHide, sectionId, sectionTitle, isHidden, onUnhide } = props;
  const location = useLocation();
  const keywords = propKeywords || location.state?.keywords || [];
  const [isEditing, setIsEditing] = useState(false);
  const [previousResponse, setPreviousResponse] = useState("");
  const { updateProductData } = useProductContext();

  const convertHowToUseToString = (howToUseData) => {
    if (!howToUseData) return "";
    if (typeof howToUseData === "string") return howToUseData;
    if (Array.isArray(howToUseData)) {
      return howToUseData.map(item =>
        typeof item === "string" ? item : JSON.stringify(item)
      ).join("\n");
    }
    return Object.entries(howToUseData)
      .map(([key, value]) => `${key}: ${value}`)
      .join("\n");
  };

  const [howToUse, setHowToUse] = useState(convertHowToUseToString(howtoUse));

  useEffect(() => {
    const howToUseString = convertHowToUseToString(howtoUse);
    setHowToUse(howToUseString);
    if (howToUseString.trim()) {
      setPreviousResponse(howToUseString);
    }
  }, [howtoUse]);

  const toggleEdit = () => {
    if (isEditing) {
      // Save the updated how to use when exiting edit mode
      const updatedData = {
        how_to_use: howToUse
      };
      updateProductData(initialSku, "how_to_use", updatedData);
    }
    setIsEditing(!isEditing);
  };

  const handleDoneClick = () => {
    setIsEditing(false);
    handleManualEdit("how_to_use", howToUse);
  };

  const handleRegenerate = async (type, formData, howToUse) => {
    let furtherDetailsToSend = "";
    let customPromptToSend = null;

    if (typeof formData === "object" && formData !== null) {
      if (formData.reason?.trim()) {
        furtherDetailsToSend = formData.reason;
      } else {
        customPromptToSend = {
          goal: formData.goal,
          role: formData.role,
          constraints: formData.constraints,
        };
      }
    } else if (typeof formData === "string") {
      furtherDetailsToSend = formData;
    }

    await handleProductRegenerate(type, furtherDetailsToSend, howToUse, customPromptToSend, previousResponse, keywords);
  };

  const getDisplayText = () => {
    const text = convertHowToUseToString(howtoUse);
    return text || howToUse;
  };


  return (
    <div className="product-section">
      <div className="section-header">
        <div className="section-title">How to use</div>
        {!previewMode && (
          isEditing ? (
            <Button variant="dark" onClick={handleDoneClick}>Done</Button>
          ) : (
            <div className="button-group">
              <BaseButton
                className="outlineprimary"
                children="Regenerate Text"
                imageSrc="/regenerate-text.svg"
                isModalOpen={true}
                handleClick={(formData) => handleRegenerate("how_to_use", formData, howToUse)}
              />
              {isHidden && onUnhide ? (
                <BaseButton
                  className="outlineprimary"
                  children="Unhide Section"
                  handleClick={onUnhide}
                />
              ) : onHide ? (
                <BaseButton
                  className="outlineprimary"
                  children="Hide Section"
                  handleClick={() => onHide(sectionId, sectionTitle)}
                />
              ) : null}
              <BaseButton
                className="outlineprimary btn-sm"
                children="Edit Text"
                imageSrc="/edit-text.svg"
                handleClick={toggleEdit}
              />
            </div>
          )
        )}
      </div>

      <div className="">
        {loading ? (
          <Skeleton height={12} width="90%" style={{ marginBottom: 5 }} count={5} />
        ) : isEditing ? (
          <textarea
            value={howToUse}
            onChange={(e) => setHowToUse(e.target.value)}
            className="product-description-input form-control"
          />
        ) : (
          <div className="description-tabs">
            <ul className="mb-0">
              {getDisplayText()
                .split("\n")
                .filter(line => line.trim() !== "")
                .map((line, index) => (
                  <li className="productDescription" key={index}>{line}</li>
                ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductHowToUse;

